import { Drawer as MantineDrawer } from "@mantine/core";
import type { CustomDrawerTitleFactory, IProps } from "./drawer-title.types";
import { componentWrapper } from "../../../utilities";
import { isValidElement } from "react";
import { Title } from "../../title";

const DrawerTitle = componentWrapper<CustomDrawerTitleFactory, IProps>(
    "DrawerTitle",
    ({ children, ...otherProps }, ref) => {
        return (
            <MantineDrawer.Title ref={ref} {...otherProps}>
                {typeof children === "string" ? (
                    <Title order={4}>{children}</Title>
                ) : isValidElement(children) ? (
                    children
                ) : undefined}
            </MantineDrawer.Title>
        );
    }
);

export { DrawerTitle };
